import { useEffect } from 'react';
import useActiveSectionStore from '../useActiveSectionStore';

const scrollOnMount = (selectedTabId) => {
  const selectedSection = document.getElementById(selectedTabId);
  const headerHeight = document.querySelector('header').offsetHeight;
  const promise = new Promise((resolve) => {
    if (selectedSection) {
      setTimeout(() => {
        window.scrollTo({
          top: selectedSection.offsetTop - headerHeight - 20,
          left: 0,
          behavior: 'smooth'
        });
        resolve();
      }, 0);
    }
  });

  return promise;
};

const useScrollOnMount = (section) => {
  const { activeSec: secInSpot, setSec } = useActiveSectionStore(
    (state) => state
  );

  useEffect(() => {
    const selectedTabId = secInSpot;
    if (selectedTabId === section)
      scrollOnMount(selectedTabId).then(() => setSec(''));
  }, [secInSpot, section, setSec]);
};

export default useScrollOnMount;
